module.exports = __webpack_public_path__ + "static/johannes-de6a3f770fb59b51c5c69f3d8e8d4f21.jpeg";